import { useState } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import ModalWrapper from '../utils/modal/ModalWrapper';
import CreateKeysModal from './CreateKeysModal';

function TeacherStudentsNav(): JSX.Element {

    let { path } = useRouteMatch();

    const [isModalVisible, setModalVisible] = useState(false);

    const showModal = () => {
        setModalVisible(wasModalVisible => !wasModalVisible);
    }

    let content = <CreateKeysModal close={showModal}/>

    return (
        <nav className="flex flex-row">
            {<ModalWrapper isVisible={isModalVisible} onBackdropClick={showModal} content={content} type={"createKeys"}/> }
            <Link to={`${path}/`}>
                <div className="p-4 text-3xl font-bold leading-tight text-teal-500 hover:bg-teal-200">
                    <i className="ri-home-2-line">{}</i>
                </div>
            </Link>
            <div onClick={showModal} className="p-4 text-3xl font-bold leading-tight text-teal-500 hover:bg-teal-200">
                <i className="ri-add-box-line">{}</i>
            </div>
            <Link to={`${path}/unusedKeys`}>
                <div className="p-4 text-3xl font-bold leading-tight text-teal-500 hover:bg-teal-200">
                    <i className="ri-key-line">{}</i>
                </div>
            </Link>
            <Link to={`${path}/usedKeys`}>
                <div className="p-4 text-3xl font-bold leading-tight text-teal-500 hover:bg-teal-200">
                    <i className="ri-user-line">{}</i>
                </div>
            </Link>
            <Link to={`${path}/results`}>
                <div className="p-4 text-3xl font-bold leading-tight text-teal-500 hover:bg-teal-200">
                    <i className="ri-file-paper-2-line">{}</i>
                </div>
            </Link>
        </nav>
    );
}

export default TeacherStudentsNav;